<script>
  import { fly } from "svelte/transition";
  import Quote from "../components/quote.svelte";
  import { pagingStore } from "../stores/paging.js";
  pagingStore.showPrev(false);
  pagingStore.showNext(false);

  import { laraStore } from "../stores/lara.js";
  laraStore.followMouse(false);
  laraStore.setCoords({ x: 100, y: 100 });
  laraStore.setOpacity(0);

  import {
    stylesBackground,
    stylesColor,
    stylesScale
  } from "../stores/styles.js";
  stylesBackground.set("white");
  stylesColor.set("black");
  stylesScale.set(0.7);

  let open = false;

  function openBook() {
    open = true;
    pagingStore.next();
    stylesScale.set(1);
  }
</script>

<style>
  .cover {
    perspective: 100000px;
    perspective-origin: center;

    height: 100%;
    width: 100%;

    box-shadow: 0 0 0 #ffffff;

    transform: rotateY(0);
    transform-origin: left center;
    transform-style: preserve-3d;
    transition: transform 2s ease-in-out,
      box-shadow 1s ease-in-out;
  }
  .cover:not(.open):hover {
    box-shadow: 0 0 2vw rgba( 0, 0, 0, 0.05 );
  }
  .cover.open {
    transform: rotateY(-180deg);
  }
  .cube {
    position: relative;
    width: 100%;
    height: 100%;
    transform-style: preserve-3d;
    backface-visibility: hidden;
  }
  .cube div {
    position: absolute;
    width: 100%;
    height: 100%;
  }
  .back {
    transform: translateZ(-1px) rotateY(180deg);
    background: linear-gradient(90deg, rgba(0,0,0,0.05) 0%, rgba(0,0,0,0.1) 100%);
  }
  .front {
    display: flex;
    align-items: center;
    justify-content: center;
    background: white;
  }
  .toggle {
    position: absolute;
    top: 0;
    left: 0;
  }
</style>

<div class="cover" class:open>
  <div class="cube">
    <div class="front">
      <Quote title="Cover">
        Kommst du mit auf eine Reise?
        <button
          on:click={openBook}
          class="block mt-5 p-5 rounded-md bg-gray-400">
          start
        </button>
      </Quote>
    </div>
    <div class="back">back</div>
  </div>
</div>
